import { createSelector } from 'reselect';
import productsByIdSelector from './productsById';

export default createSelector(productsByIdSelector, (products) => Object.values(products));
